import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  AddBuinessPlaceStyle,
  BusinessUpdateList,
  LoaderContainer,
  PostedUserDetails,
} from './Buisness.style';
import CustomCarousel from 'components/CustomCarousel';
import {
  BasicIconButton,
  BrandIconSpinner,
  Button,
  CloseIcon,
  CustomPopover,
  Input,
  Modal,
} from 'components';
import {
  addBuinessPlace,
  DeleteBuinessByuserId,
  DeleteBuinessUpdatesByuserId,
  getBuinessPlaceList,
  getBusinessImagesList,
  getBusinessListUpdate,
} from 'redux/features/BuinessPlaceSlice';
import {
  EndStyle,
  PostArrowBack,
  PostBox,
  PostPopOver,
} from 'pages/home/Home.style';
import BasicChips from 'components/Chip';
import {
  getBusinessCategoryList,
  getCountryList,
} from 'redux/features/DropDownSlice';
import { AddMoreStyle } from 'pages/addprofile/AddProfile.style';
import { Notification } from 'components/CustomNotification';
import TextEditor from 'components/TextEditor';
import { ClearLoading, SetLoading } from 'redux/services/LoadingService';
import { ReactComponent as DeleteFilled } from 'assert/images/Profile/delete.svg';
import { ReactComponent as EditFilled } from 'assert/images/Profile/edit.svg';
import UploadImagePreview from 'components/UploadImagePreview';
import { ReactComponent as Like } from 'assert/images/Common/thumbUp.svg';
import { ReactComponent as DisLike } from 'assert/images/Common/thumbDown.svg';
import { ReactComponent as FillLike } from 'assert/images/Common/thumbUpFilled.svg';
import { ReactComponent as FillDisLike } from 'assert/images/Common/thumbDownFilled.svg';
import { Divider } from '@mui/material';
import { BusinessRatings } from './BusinessList';
import { ReactComponent as Add } from 'assert/images/Profile/add.svg';
import { ReactComponent as More } from 'assert/images/Home/moreHorizantal.svg';
import { ReactComponent as Delete } from 'assert/images/More/delete.svg';
import { ReactComponent as PostEdit } from 'assert/images/More/postEdit.svg';
import { ReactComponent as SampleProfile } from 'assert/images/Common/profileImg.svg';
import { ReactComponent as Report } from 'assert/images/More/report.svg';
import AddBusinessPlace from './AddBusinessPlace';
import DynModel from 'components/Modal';
import BusinessImages from './BusinessImages';
import { Virtuoso } from 'react-virtuoso';
import { Business, businessLikes, businessUnlikes } from 'redux/APIEndPoint';
import moment from 'moment';
import clsx from 'clsx';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import SwipeableEdgeDrawer from 'components/SwipeableDrawer';
import { handleOpenLinkInBrower, swipeModalWidth } from 'utils/helper';
import useWindowDimensions from 'components/Dimention';
import ReportModal from 'components/ReportModal';

export default function DetailView() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const { countryList } = useSelector((state) => state?.DropdownReducer);
  const { loading } = useSelector((state) => state.Loading);
  const { getLists, getImages } = useSelector(
    (state) => state.BusinessPlaceSlice
  );
  const { businessCategory } = useSelector((state) => state?.DropdownReducer);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const BusinessItem = getLists;

  const [deleteOpen, setDeleteOpen] = useState(null);
  const [editId, seteditId] = useState(null);
  const [Addmore, setAddmore] = useState(false);
  const [BusinessDetailUpdateList, setBusinessDetailUpdateList] = useState([]);
  const [textLength, setTextLength] = useState(0);
  const [likeCount, setlikeCount] = useState({});
  const [likedUsers, setlikedUsers] = useState({});
  const [UnlikedUsers, setUnlikedUsers] = useState({});
  const [UnlikeCount, setUnlikeCount] = useState({});
  const [openPopover, setOpenPopover] = useState(false);
  const [businessEditData, setBusinessEditData] = useState(null);
  const [businessImgData, setBusinessImgData] = useState(null);
  const [imageEdit, setImageEdit] = useState(false);
  const [businessDeleteID, setBusinessDeleteID] = useState(null);
  const [isHasMore, setIsHasMore] = useState(0);
  const [isReportModalOpen, setIsReportModalOpen] = useState("");

  const [state, setState] = useState({
    image: [],
    title: '',
    description: '',
  });
  const [errMsg, seterrMsg] = useState({
    image: '',
    title: '',
    description: '',
  });
  const [scrollData, setScrollData] = useState({ page: 0, size: 20 });

  const BusinessUpdateApi = () => {
    dispatch(getBusinessListUpdate(id))
      .then((res) => {
        setBusinessDetailUpdateList(res?.data?.data);
        setIsHasMore(res?.data?.data?.hasMore);
        dispatch(ClearLoading());
      })
      .catch(() => {
        dispatch(ClearLoading());
      });
  };
  useEffect(() => {
    if (id) {
      dispatch(
        getBuinessPlaceList(
          `${Business}/${id}?clientOffSet=${new Date().getTimezoneOffset()}`
        )
      );
      dispatch(getBusinessImagesList(id));
      BusinessUpdateApi();
      businessCategory.length === 0 && dispatch(getBusinessCategoryList());
    }
  }, [id]);

  useEffect(() => {
    countryList?.length === 0 && dispatch(getCountryList());
  }, []);

  const FilterLabel = (val, array) => {
    return array.filter((data) => data.value === val)?.[0]?.label;
  };

  const SubmitApiCall = (edit) => {
    const formData = new FormData();
    formData.set('businessPageId', BusinessItem?.id);
    formData.append(
      'image',
      edit ? [] : state?.image?.[0] ? state.image[0] : ''
    );
    formData.set('title', state.title);
    formData.set('description', state.description);
    dispatch(SetLoading());
    dispatch(
      addBuinessPlace(
        formData,
        `${Business}/updates${editId ? `/${editId}` : ''}`,
        editId ? 'put' : 'post'
      )
    )
      .then((ress) => {
        dispatch(ClearLoading());
        if (ress.data.success === true) {
          Notification('success', ress?.data?.message);
          ClearFields();
          BusinessUpdateApi(id);
        } else {
          Notification('error', ress?.data?.message);
        }
        setAddmore(false);
        seteditId(null);
      })
      .catch((value) => {
        dispatch(ClearLoading());
        Notification('error', value?.response?.data?.message);
      });
  };

  const Submit = () => {
    handleValidation();
    const validation = Object.keys(errMsg).every((it) => errMsg[it] === '');
    if (validation) {
      if (
        state?.image?.length > 0 &&
        state?.image?.find((li) => li.size / 1024 ** 2 > 8)
      ) {
        Notification('warning', 'Image size should not exceed 8 MB');
      } else {
        SubmitApiCall();
      }
    }
  };

  const handleChange = (val, key) => {
    setState((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const DeleteList = () => {
    dispatch(SetLoading());
    dispatch(
      DeleteBuinessUpdatesByuserId(
        deleteOpen?.id,
        deleteOpen?.image ? [deleteOpen?.image] : []
      )
    )
      .then((res) => {
        setDeleteOpen(null);
        if (res.data.message === 'Page updates was deleted successfully!') {
          Notification('success', res?.data?.message);
        } else {
          Notification('warning', res?.data?.message);
        }
        setTimeout(() => {
          setDeleteOpen(null);
          dispatch(ClearLoading());
          BusinessUpdateApi(deleteOpen?.businessPageId);
        }, 300);
      })
      .catch(() => {
        setTimeout(() => {
          setDeleteOpen(null);
          dispatch(ClearLoading());
        }, 300);
      });
  };

  const AddLikeAndDislike = (data, input, type) => {
    dispatch(SetLoading());
    const payloadlike = {
      like: input,
      likedBy: getProfile.userId,
      businessPageUpdatesId: data.id,
      businessPageId: id,
    };

    const payloadunlike = {
      unlike: input,
      unlikedBy: getProfile.userId,
      businessPageUpdatesId: data.id,
      businessPageId: id,
    };
    dispatch(
      addBuinessPlace(
        type === 'like' ? payloadlike : payloadunlike,
        type === 'like' ? businessLikes : businessUnlikes,
        'post'
      )
    )
      .then((ress) => {
        if (ress.data.success === true) {
          Notification('success', ress?.data?.message);
          ClearFields();
          BusinessUpdateApi(id);
        } else {
          dispatch(ClearLoading());
          Notification('error', ress?.data?.message);
        }
        setAddmore(false);
        seteditId(null);
      })
      .catch((value) => {
        dispatch(ClearLoading());
        Notification('error', value?.response?.data?.message);
      });
  };

  const handleItemContent = (_, data) => {
    return (
      <div className="update-item-container">
        <div className="card-container">
          <div className="update-content">
            {data.image.startsWith('https') && (
              <div className="image-div-parent">
                <img src={data.image} />
              </div>
            )}
            <div className="title">{data?.title}</div>
            <div
              className={`description-section`}
              dangerouslySetInnerHTML={{ __html: data?.description }}
            ></div>
            <div className="updates-date">
              {moment(data?.createdAt).fromNow(true)}
            </div>
          </div>
          <div className="card-footer-div">
            <div className="likesdiv">
              <BasicIconButton
                size="small"
                ariaLabel={'like-icon'}
                onClick={() =>
                  !loading &&
                  AddLikeAndDislike(
                    data,
                    !likedUsers['likedusers' + data.id],
                    'like'
                  )
                }
                className={
                  likedUsers['likedusers' + data.id] ? 'activelike' : ''
                }
                icon={
                  likedUsers['likedusers' + data.id] ? <FillLike /> : <Like />
                }
              />
              <span>
                {likeCount['likecount' + data.id] >= 1
                  ? likeCount['likecount' + data.id]
                  : ''}
              </span>
              <BasicIconButton
                size="small"
                onClick={() =>
                  !loading &&
                  AddLikeAndDislike(
                    data,
                    // !UnlikedUsers['unlikedusers' + data.id],
                    !data.isUnLiked,
                    'unlike'
                  )
                }
                className={clsx(
                  // UnlikedUsers['unlikedusers' + data.id] ? 'activeunlike' : '',
                  'business-thumb-down'
                )}
                icon={
                  // UnlikedUsers['unlikedusers' + data.id]
                  data.isUnLiked ? <FillDisLike /> : <DisLike />
                }
                ariaLabel={'dislike-icon'}
              />
              <span>
                {UnlikeCount['unlikecount' + data.id] >= 1
                  ? UnlikeCount['unlikecount' + data.id]
                  : ''}
              </span>
            </div>
            {getProfile?.userId === BusinessItem?.createdBy && (
              <div className="editdiv">
                <div className="edit-icon">
                  <BasicIconButton
                    size="small"
                    icon={<EditFilled />}
                    onClick={() => {
                      setAddmore(true);
                      EditDetails(data);
                      seteditId(data.id);
                    }}
                    ariaLabel={'edit-icon'}
                  />
                </div>
                <div className="remove-icon">
                  <BasicIconButton
                    size="small"
                    icon={<DeleteFilled />}
                    onClick={() => setDeleteOpen(data)}
                    ariaLabel={'remove-icon'}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const EditDetails = (data) => {
    setState((prev) => ({
      ...prev,
      title: data.title,
      description: data.description,
      image: data.image !== '' ? [data.image] : [],
    }));
  };

  const ClearFields = () => {
    Object.keys(state).map((key) => {
      return setState((prevState) => ({
        ...prevState,
        [key]: '',
      }));
    });
  };
  const handleValidation = () => {
    if (state.description === '') {
      errMsg.description = 'Field Required';
    } else if (state.description !== '' && textLength > 1500) {
      errMsg.description = 'Maximum Limit 1500 only';
    } else {
      errMsg.description = '';
    }
    if (state.title === '') {
      errMsg.title = 'Field Required';
    } else {
      errMsg.title = '';
    }

    if (state.title === '') {
      errMsg.title = 'Field Required';
    } else {
      errMsg.title = '';
    }
    seterrMsg((prev) => ({
      ...prev,
    }));
  };

  useEffect(() => {
    BusinessDetailUpdateList?.rows?.data?.forEach((data) => {
      likeCount['likecount' + data.id] = data.likeCount;
      UnlikeCount['unlikecount' + data.id] = data.unlikeCount;
      likedUsers['likedusers' + data.id] = data.isLiked === 1;
      UnlikedUsers['unlikedusers' + data.id] = data.unlikeCount === 1;
    });
    setlikeCount((prev) => ({
      ...prev,
    }));
    setUnlikeCount((prev) => ({
      ...prev,
    }));
    setlikedUsers((prev) => ({
      ...prev,
    }));
    setUnlikedUsers((prev) => ({
      ...prev,
    }));
  }, [BusinessDetailUpdateList]);

  const actionDropdown = (item) => {
    return (
      <PostPopOver>
        {getProfile?.userId === item?.createdBy ? (
          <>
            <div
              onClick={() => {
                setBusinessEditData(item);
                setOpenPopover(false);
              }}
            >
              <PostEdit />
              <div>{t('BusinessPlace.EditThePost')}</div>
            </div>
            <div
              onClick={() => {
                setBusinessImgData(item);
                getImages?.image?.length > 0 && setImageEdit(true);
                setOpenPopover(false);
              }}
            >
              <Add className="editlist-icon" />
              <div>
                {getImages?.image?.length > 0
                  ? t('BusinessPlace.AddEditImage')
                  : t('BusinessPlace.AddImages')}
              </div>
            </div>
            <div
              onClick={() => {
                setBusinessDeleteID(item.id);
                setOpenPopover(false);
              }}
              className="deletelist-icon"
            >
              <Delete />
              <div>{t('BusinessPlace.Delete')}</div>
            </div>
          </>
        ) : (
          <div
            onClick={() => {
              setIsReportModalOpen(item.id);
              setOpenPopover(false);
            }}
            className="deletelist-icon"
          >
            <Report />
            <div>{t('BusinessPlace.Report')}</div>
          </div>
        )}
      </PostPopOver>
    );
  };

  const handleDeleteListItem = () => {
    dispatch(SetLoading());
    dispatch(DeleteBuinessByuserId(`/${businessDeleteID}`))
      .then((res) => {
        setBusinessDeleteID(null);
        if (res.data.success === true) {
          Notification('success', res?.data?.message);
          navigate('/business-hub');
        } else {
          Notification('warning', res?.data?.message);
        }
        setTimeout(() => {
          setBusinessDeleteID(null);
          dispatch(ClearLoading());
        }, 300);
      })
      .catch(() => {
        setTimeout(() => {
          setBusinessDeleteID(null);
          dispatch(ClearLoading());
        }, 300);
      });
  };

  const fetchMoreData = useCallback(
    (page) => {
      if (scrollData.page !== page) {
        setScrollData({
          page: scrollData.page + 1,
          size: scrollData.size,
        });
      }
    },
    [scrollData.page]
  );

  const renderLocation = (value) => {
    if (BusinessItem?.isWorldWide) return 'Worldwide';
    let locations = [];
    if (typeof value === 'string') {
      try {
        locations = JSON.parse(value.replace(/'/g, '"'));
      } catch (e) {
        console.error('Invalid location JSON:', value);
        return null;
      }
    } else if (Array.isArray(value)) {
      locations = value;
    }
    return locations.map((val, i) => (
      <BasicChips
        key={`location_${i}`}
        label={`${FilterLabel(val?.country, countryList)}, ${val.city}`}
      />
    ));
  };

  const handleGetBusinessUpdatesContent = () => {
    return (
      <AddBuinessPlaceStyle>
        <BrandIconSpinner loading={loading} />
        <AddMoreStyle>
          <div className="cmy-list-parent-div">
            <UploadImagePreview
              isReplace
              isDelete
              maxFiles={1}
              label={t('BusinessPlace.Image')}
              handleFileSRC={(data) => handleChange(data, 'image')}
              value={state?.image || ''}
              types="imageupload"
              onCloseFiles={(data) => {
                setState((prev) => ({
                  ...prev,
                  image: [],
                }));
              }}
            />
            <Input
              label={t('BusinessPlace.Title')}
              value={state.title}
              onChange={(data) => handleChange(data, 'title')}
              errMsg={errMsg.title}
              required
            />
            <TextEditor
              label={t('BusinessPlace.Description')}
              required
              onChange={(data) => handleChange(data, 'description')}
              value={state.description}
              errMsg={errMsg.description}
              maxLength={1500}
              callbackTextLength={setTextLength}
            />
          </div>
          <div className="modal-footer">
            <Button
              label={t('BusinessPlace.Submit')}
              onClick={Submit}
              type={'text'}
            />
            <Button
              label={t('BusinessPlace.Close')}
              onClick={() => setAddmore(false)}
              type={'text'}
            />
          </div>
        </AddMoreStyle>
      </AddBuinessPlaceStyle>
    );
  };

  return (
    <>
      <Helmet>
        <title>
          {BusinessItem?.name
            ? `${
                BusinessItem.name.length > 50
                  ? BusinessItem.name.slice(0, 50) + '...' + '| WafyNet'
                  : BusinessItem.name + ' | WafyNet'
              }`
            : 'Business Details | WafyNet'}
        </title>
        <meta
          name="description"
          content={
            BusinessItem?.title ||
            'Discover businesses, explore profiles, and connect with companies through WafyNet.'
          }
        />
      </Helmet>
      <AddBuinessPlaceStyle>
        <PostArrowBack className="post-back">
          <CloseIcon
            iconType={'back'}
            onClick={() => navigate('/business-hub')}
          />
          <div>{t('BusinessPlace.BusinessHub')}</div>
        </PostArrowBack>
        {!BusinessItem?.name && (
          <LoaderContainer>
            <BrandIconSpinner loading={!BusinessItem?.name} />
          </LoaderContainer>
        )}
        {BusinessItem?.name && (
          <PostBox>
            <div className="business-more-btn">
              <CustomPopover
                isOpen={openPopover}
                handlePopoverClick={() => setOpenPopover(true)}
                action={
                  <BasicIconButton
                    icon={<More onClick={() => setOpenPopover(true)} />}
                    size="small"
                  />
                }
                content={actionDropdown(BusinessItem)}
              />
            </div>
            {getImages?.image?.length > 0 && (
              <CustomCarousel items={getImages?.image} />
            )}
            <div className="business-hub-titles">
              <span
                className="company-link"
                onClick={() => handleOpenLinkInBrower(BusinessItem?.website)}
              >
                {BusinessItem?.name}
              </span>{' '}
              - {BusinessItem.title}
            </div>
            <div className="detail-view">
              <label>{t('BusinessPlace.Services')}</label>
              <div className="description-section">
                <div
                  dangerouslySetInnerHTML={{ __html: BusinessItem?.service }}
                />
              </div>
            </div>
            <div className="detail-view">
              <label>{t('BusinessPlace.ServiceLocation')}</label>
              <label>{renderLocation(BusinessItem?.location)}</label>
            </div>
            <div className="detail-view business-contact-details">
              <label>{t('BusinessPlace.ContactDetails')}</label>
              <label>{BusinessItem?.contact}</label>
            </div>
            <Divider />
            <PostedUserDetails>
              <div className="posted-user-title">
                {t('BusinessPlace.Postedby')}
              </div>
              <div className="posted-user-container posted-user-container-width">
                <div className="posted-user-img">
                  {BusinessItem?.postedUserInfo?.profileImage ? (
                    <img
                      className="user-profile-img"
                      src={BusinessItem?.postedUserInfo?.profileImage}
                    />
                  ) : (
                    <SampleProfile className="user-profile-img" />
                  )}
                </div>
                <div className="posted-username-details">
                  <span
                    onClick={() =>
                      navigate(
                        '/profile/' + BusinessItem.postedUserInfo.username
                      )
                    }
                  >
                    {BusinessItem?.postedUserInfo?.displayName}
                  </span>
                  <span className="posted-username">
                    {' '}
                    · {` @${BusinessItem?.postedUserInfo?.username}`}
                  </span>
                  <div className="posted-headline">
                    {BusinessItem?.postedUserInfo?.headline}
                  </div>
                </div>
              </div>
            </PostedUserDetails>
            <div className="action-container">
              <div className="rating-container">
                {BusinessItem?.id && BusinessItem?.status === 1 && (
                  <BusinessRatings
                    data={BusinessItem}
                    handleUpdateData={() =>
                      dispatch(
                        getBuinessPlaceList(
                          `${Business}/${id}?clientOffSet=${new Date().getTimezoneOffset()}`
                        )
                      )
                    }
                  />
                )}
              </div>
              <div className="business-hub-detail-actions">
                {getProfile?.userId === BusinessItem?.createdBy && (
                  <>
                    {BusinessItem?.status === 1 && (
                      <>
                        <Divider
                          orientation="vertical"
                          variant="middle"
                          flexItem
                        />
                        <div className="add-more-section">
                          <Button
                            type="text"
                            label={t('BusinessPlace.AddUpdates')}
                            startIcon={<Add />}
                            onClick={() => {
                              ClearFields();
                              setAddmore(true);
                            }}
                          />
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </PostBox>
        )}
        {BusinessDetailUpdateList?.rows?.data?.length > 0 && (
          <>
            <h3 className="updates-header">
              {t('BusinessPlace.CompanyUpdates')}
            </h3>
            <div className="business-detail-view">
              <Virtuoso
                data={BusinessDetailUpdateList?.rows?.data || []}
                useWindowScroll
                increaseViewportBy={{ top: 4000, bottom: 4000 }}
                components={{
                  Footer: () => {
                    return (
                      !isHasMore && (
                        <EndStyle>
                          <span>* * *</span>
                        </EndStyle>
                      )
                    );
                  },
                }}
                endReached={
                  isHasMore
                    ? () => fetchMoreData(scrollData.page + 1)
                    : () => {}
                }
                itemContent={(index, item) => (
                  <BusinessUpdateList>
                    {handleItemContent(index, item)}
                  </BusinessUpdateList>
                )}
              />
            </div>
          </>
        )}
        <Modal
          removeHeader
          modalchanges="headerProfile"
          handleCancelModal={() => setDeleteOpen(null)}
          openModal={deleteOpen !== null}
          content={
            <>
              <BrandIconSpinner loading={loading} />
              <div className="confirmModal">
                <div className="title">{t('BusinessPlace.DeleteRecord')}</div>
                <div>
                  <Button
                    label={t('BusinessPlace.Cancel')}
                    onClick={() => setDeleteOpen(null)}
                  />
                  <Button
                    label={t('BusinessPlace.Yes')}
                    color="error"
                    onClick={DeleteList}
                  />
                </div>
              </div>
            </>
          }
        />
        {isSmallScreen ? (
          <SwipeableEdgeDrawer
            title={t('BusinessPlace.Updates')}
            openDrawer={Addmore}
            handleCloseDrawer={() => setAddmore(false)}
          >
            {handleGetBusinessUpdatesContent()}
          </SwipeableEdgeDrawer>
        ) : (
          <Modal
            modelTitle={t('BusinessPlace.Updates')}
            handleCancelModal={() => setAddmore(false)}
            openModal={Addmore}
            PaperProps={{
              sx: {
                width: '100%',
                maxWidth: '600px!important',
              },
            }}
            modalchanges="Business-update-modal"
            content={handleGetBusinessUpdatesContent()}
          />
        )}
        <Modal
          content={
            <AddBusinessPlace
              closeModal={() => setBusinessEditData(null)}
              editData={businessEditData}
              handleUpdateItem={() =>
                dispatch(
                  getBuinessPlaceList(
                    `${Business}/${id}?clientOffSet=${new Date().getTimezoneOffset()}`
                  )
                )
              }
            />
          }
          openModal={businessEditData !== null}
          modelTitle={t('BusinessPlace.GrowYourBusiness')}
          modalchanges="commonModal"
          handleCancelModal={() => setBusinessEditData(null)}
        />
        {isSmallScreen ? (
          <SwipeableEdgeDrawer
            title={t('BusinessPlace.BusinessImages')}
            openDrawer={businessImgData}
            handleCloseDrawer={() => setBusinessImgData(null)}
          >
            <BusinessImages
              businessImgData={businessImgData}
              ImageEdit={imageEdit}
              handleCancelModal={() => setBusinessImgData(null)}
            />
          </SwipeableEdgeDrawer>
        ) : (
          <DynModel
            handleCancelModal={() => setBusinessImgData(null)}
            openModal={businessImgData}
            modalchanges={'comment-modal'}
            modelTitle={t('BusinessPlace.BusinessImages')}
            content={
              <BusinessImages
                businessImgData={businessImgData}
                ImageEdit={imageEdit}
                handleCancelModal={() => setBusinessImgData(null)}
              />
            }
          />
        )}
        <Modal
          removeHeader
          modalchanges="headerProfile"
          handleCancelModal={() => setBusinessDeleteID(null)}
          openModal={businessDeleteID !== null}
          content={
            <>
              <BrandIconSpinner loading={loading} />
              <div className="confirmModal">
                <div className="title">{t('BusinessPlace.DeleteRecord')}</div>
                <div>
                  <Button
                    label={t('BusinessPlace.Cancel')}
                    type="text"
                    onClick={() => setBusinessDeleteID(null)}
                  />
                  <Button
                    label={t('BusinessPlace.Yes')}
                    color="error"
                    onClick={handleDeleteListItem}
                  />
                </div>
              </div>
            </>
          }
        />
        <ReportModal
          resourceType={'businesspage'}
          resourceId={isReportModalOpen}
          handleCloseReportModal={(data) => {
            setIsReportModalOpen(false);
            if (data?.closePopover) {
              setOpenPopover(false);
            }
          }}
        />
      </AddBuinessPlaceStyle>
    </>
  );
}
